import { Component, OnInit, ChangeDetectorRef  } from '@angular/core';
import { MediaIntegrationLogService } from '../../services/media-integration-log.service';
import {
  MediaIntegrationLogLookupRequest,
  MediaIntegrationLogLookupResponseItem
} from '../../models/media-integration-log.models';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-media-integration-log',
  imports: [FormsModule, CommonModule],
  templateUrl: './media-integration-log.component.html',
  styleUrl: './media-integration-log.component.css',
})
export class MediaIntegrationLogComponent {
  constructor(private mediaIntegrationLogService: MediaIntegrationLogService, private cdr: ChangeDetectorRef) {
   
  }

  model: MediaIntegrationLogLookupRequest = {
    Page: 1,
    PageSize: 20,
    SearchText: '',
    ShowErrorsOnly: false
  };
  
  items: MediaIntegrationLogLookupResponseItem[] = [];
  total: number = 0;
  totalFiltered: number = 0;
  totalPages: number = 0;
  currentItem: MediaIntegrationLogLookupResponseItem | null = null;

  ngOnInit(): void {
     this.loadItems();
  }

  loadItems(): void {
    this.mediaIntegrationLogService.lookup(this.model).subscribe({
      next: (response) => {
        this.items = response.Items;
        this.total = response.Total;
        this.totalFiltered = response.TotalFiltered;
        this.totalPages = Math.floor((this.totalFiltered + this.model.PageSize - 1) / this.model.PageSize);

        if (this.model.Page > this.totalPages) {
            this.model.Page = 1;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
      }
    });
  }
  nextPage(): void {
    if (this.model.Page < this.totalPages) {
      this.model.Page++;
      this.loadItems();
    }
  }

  previousPage(): void {
    if (this.model.Page > 1) {
      this.model.Page--;
      this.loadItems();
    }
  }

  toggleShowErrorsOnly(): void {
    this.model.ShowErrorsOnly = !this.model.ShowErrorsOnly;
    this.model.Page = 1;
    this.loadItems();
  }
  
  getPrettyData(data: string): string {
    return JSON.stringify(JSON.parse(data), null, 2);
  }
}
